import { useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { useI18n } from '@namespace/i18n';
import {
  LOBBY_RECOMMENDED_GAMES_AMOUNT,
  PLAYERS_CHOICE_TODAY_CATEGORY,
  SECTION_TYPES
} from '../../../constants';
import { useGamesData } from '../useGamesData';
import { useGetIsRecommendedGamesLoaded } from '../useGetIsRecommendedGamesLoaded';
import { useGetRecommendedGamesIds } from '../useGetRecommendedGamesIds';

interface DynamicRecommendedCategory {
  feedName: string;
  suggesterServiceEntityName: string;
  showDynamicRecommendedCategory: boolean;
}

export const useDynamicRecommendedCategory = ({
  feedName,
  suggesterServiceEntityName,
  showDynamicRecommendedCategory
}: DynamicRecommendedCategory) => {
  const { t } = useI18n();

  const gamesData = useGamesData();

  const isRecommendedGamesLoaded = useGetIsRecommendedGamesLoaded(
    suggesterServiceEntityName
  );

  const dynamicRecommendedGamesIds = useGetRecommendedGamesIds(
    suggesterServiceEntityName,
    feedName
  );

  const dynamicRecommendedGames = useMemo(
    () => dynamicRecommendedGamesIds.map((gameId: string) => gamesData[gameId]),
    [dynamicRecommendedGamesIds, gamesData]
  );

  const preparedDynamicRecommendedCategory = useMemo(
    () => ({
      id: PLAYERS_CHOICE_TODAY_CATEGORY.id,
      type: SECTION_TYPES.CATEGORY_RECOMMENDED,
      title: t(PLAYERS_CHOICE_TODAY_CATEGORY.title),
      categoryGames: dynamicRecommendedGames,
      maxGamesAmount: LOBBY_RECOMMENDED_GAMES_AMOUNT,
      isCategoryLoading: !isRecommendedGamesLoaded
    }),
    [t, dynamicRecommendedGames, isRecommendedGamesLoaded]
  );

  if (!showDynamicRecommendedCategory || isEmpty(dynamicRecommendedGames)) {
    return null;
  }

  return preparedDynamicRecommendedCategory;
};
